import React from 'react';
import './Header.css';
import logo from '../assets/odmaralistehana-logo.png';

const Header = () => {
  return (
    <header className="header">
      <div className="header-overlay">
        <div className="container">
          <div className="header-content">
            <img src={logo} alt="Odmaralište Hana Logo" className="header-logo" />
            <h1>Odmaralište Hana</h1>
            <p>Ugodno mjesto za vaš odmor i uživanje</p>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
